/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {getStatus, SubscriptStatus} from '../components/sidesheet/SubscriptionDetails';

// defines the prop definitions for Asset Details ...
export type assetDetailsProps = {
  currentPlan: GenericObject,
  status: SubscriptStatus,
  color: string
};

/**
 * Provides a utility hook to retreive current plan, status and color
 *
 * ```typescript
 *
 *   import {useAssetDetails} from '../../hooks/useAssetDetails';
 *   const {
 *     currentPlan,
 *     status,
 *     color
 *   } = useAssetDetails(asset);
 *
 * ```
 */
export const useAssetDetails = (asset): assetDetailsProps => {
  const {currentPlan} = asset?.subscriptionData || {};
  const status        = getStatus(currentPlan);
  return {
    currentPlan : currentPlan,
    status      : status,
    color       : getColor(status)
  };
};

export const getColor = (status: SubscriptStatus): string => {
  const warningStatus = [SubscriptStatus.expired, SubscriptStatus.cancelled, SubscriptStatus.stolen];
  const color = status === SubscriptStatus.active ? 'caGreen' : warningStatus.indexOf(status) > -1 ? 'caRed': 'grey3';
  return dlsColor(color);
};

export default useAssetDetails;
